const FormData = require('form-data');
const stringify = require('json-stringify-safe');
import algoliasearch from 'algoliasearch/lite';

const register = {
  namespaced: true,
  state: {
    registers: {},
    observers: {
      counts: { snapshots: [] }
    },
    mongodb: {},
    loading: {},
    counters: {},
    lastAlgoliaReqParams: {},
    recentRemove: false,
  },
  getters: {
  },
  mutations: {
    setRegister(state, { register, data, unshift = false }) {
      if (!state.registers[register]) { this._vm.$set(state.registers, [register], []) }
      const ix = state.registers[register].findIndex(x => x.id == data.id)
      if (ix > -1) {
        this._vm.$set(state.registers[register], [ix], data)
      } else if (unshift && !state.recentRemove) {
        state.registers[register].unshift(data)
      } else {
        state.registers[register].push(data)
      }
      state.recentRemove = false
    },
    removeRegister(state, { register, data }) {
      const ix = state.registers[register].findIndex(x => x.id == data.id)
      if (ix > -1) {
        state.registers[register].splice(ix, 1)
      }
    },
    resetRegister(state, register) { this._vm.$set(state.registers, [register], []) },
    setRecentRemove(state, payload) { state.recentRemove = payload },
    resetRegisters(state) { this._vm.$set(state, 'registers', {}) },
    setLoading(state, {register, status}) { 
      this._vm.$set(state.loading, [register], status) 
    },
    setCounter(state, { collection, count }) {
      this._vm.$set(state.counters, collection, count)
    },
    resetCounters(state) { state.counters = {} },
  },
  actions: {
    // GPEmpresa
    getGpEmpresa({ rootState }, collection) {
      let gpEmpresa = ''
      if (collection != '_configs' && rootState.collectionStructure && Object.prototype.hasOwnProperty.call(rootState.collectionStructure, collection)) {
        if (rootState.collectionStructure[collection].gpEmpresa == 'e') {
          gpEmpresa = rootState.companySelected.M0_CODIGO + '0'
        }
      }
      return gpEmpresa
    },

    // Filial
    getFilial({ rootState }, collection) {
      let filial = ''
      if (collection != '_configs' && rootState.collectionStructure && Object.prototype.hasOwnProperty.call(rootState.collectionStructure, collection)) {
        if (rootState.collectionStructure[collection].filial == 'e') {
          filial = rootState.companySelected.M0_CODFIL
        } else {
          filial = ' '.repeat(rootState.collectionStructure.filialTam)
        }
      }
      return filial
    },

    mountedFilters({ rootState }, { ref, filters, register, forceFilter = false }) {
      try {
        const user = rootState.auth.user // Disponivel para Filtro
        // DESABILITA FILTROS PARA SUPER ADMIN OU PAPEL ESTEJA LIBERADO
        if (!forceFilter && (user?.claims?.admin || user?.rules.some(x => x.claims && x.claims[register] && x.claims[register].noFilters))) return ref || []
        // if (user?.claims?.admin || user?.rules.some(x => x.claims && x.claims[register] && x.claims[register].noFilters)) return ref || []

        let ret = []

        filters.forEach(el => {
          let { key, operator, value, expectedValue } = el
          // console.info('FILTER =>', key, operator, value, expectedValue)

          // Validation
          if (
            !key
            || !operator
            || (typeof value != 'boolean' && !value)
            || (Array.isArray(value) && !value.length > 0)
          ) throw { error: 'Malformed Filter', filter: el }

          // if (key.includes('${')) key = eval(key)
          if (typeof value == 'string' && value.includes('${')) value = eval(value)

          // console.info('value', value)

          // Array
          if (value == undefined || value == 'undefined') value = ''
          if (typeof value == 'string' && value.includes(',') && expectedValue && expectedValue === 'array') value = value.split(",")
          else if (typeof value == 'string' && value && expectedValue && expectedValue === 'array') value = [value]

          // console.info('FORMATED FILTER =>', key, operator, value, user)
          if (!!key && !value) throw { error: 'Empty Filter', filter: el }
          else if (!!key && !!value && ref) ref = ref.where(key, operator, value)
          else if (!!key && !!value) ret.push({ key, operator, value })
        })

        return (ref) ? ref : ret
      } catch (error) {
        console.error(error)
        return null
      }
    },
   
    // OBSERVER
    async observer({ state, dispatch, rootState }, { collection, register, filters, details, orderBy, limit = 30, forceFilter = false }) {
      if (!state.registers[register]) { this._vm.$set(state.registers, [register], []) }
      if (!state.loading[register]) { this._vm.$set(state.loading, [register], true) }


      // PREPARE ENVIROMENT
      const gpEmpresa = await dispatch('getGpEmpresa', collection)
      const filial = await dispatch('getFilial', collection)
      collection = collection + gpEmpresa

      dispatch('count', { collection: 'searchAlgolian' })
      // dispatch('count', { collection })

      let ref = this._vm.$db().collection(collection)

      // FILTERS
      if (filters) ref = await dispatch('mountedFilters', { ref, filters, register, forceFilter })
      if (!ref) return this._vm.$set(state.loading, [register], false)

      ref = ref.where('lifeControl.deletedAt', '==', null)
      if (filial) ref = ref.where('filial', '==', filial)

      // ORDER BY
      let order = (Array.isArray(orderBy)) ? orderBy : [orderBy]
      for (const el of order) {
        if (el && typeof el == 'string') {
          ref = ref.orderBy(el)
        } else if (el && typeof el != 'string') {
          ref = ref.orderBy(el.key, el.mod)
        } else {
          ref = ref.orderBy(this._vm.$db.FieldPath.documentId(), 'desc')
        }
      }

      // LIMIT
      ref = ref.limit(limit)

      // Grava Referencia e register para paginação
      if (!state.observers[register]) { state.observers[register] = {} }
      this._vm.$set(state.observers[register], 'ref', ref)
      this._vm.$set(state.observers[register], 'register', register)
      this._vm.$set(state.observers[register], 'details', details)
      this._vm.$set(state.observers[register], 'orderBy', orderBy)

      // SNAPSHOT
      // console.info('observer', collection, register, filters, details, orderBy, limit, ref)
      const before = this._vm.$_.before(2, snapshot => dispatch('processregister', { snapshot, collection, register, details, orderBy }));
      const after = this._vm.$_.after(2, snapshot => dispatch('processregister', { snapshot, collection, register, details, orderBy, unshift: true }));
      const registerSnapshot = ref.onSnapshot(snapshot => { before(snapshot); after(snapshot) })

      // Grava listener para encerramento posterior
      if (state.observers[register].snapshots && state.observers[register].snapshots.length > 0) { state.observers[register].snapshots.push(registerSnapshot) }
      else { state.observers[register].snapshots = [registerSnapshot] }
      this._vm.$set(state.observers[register], 'snapshots', state.observers[register].snapshots)
    },
    nextObserver({ state, dispatch }, { register }) {
      const ref = state.observers[register].ref
      const collection = state.observers[register].register
      const details = state.observers[register].details
      const orderBy = state.observers[register].orderBy
      const lastDocCursor = state.observers[register].lastDocCursor
      if (!lastDocCursor) { return }

      let startAfter = ''
      if (lastDocCursor.length == 1) {
        startAfter = lastDocCursor[0]
      } else {
        for (const el of lastDocCursor) {
          startAfter += `'${el}', `
        }
        startAfter = startAfter.slice(0, -2)
      }
      ref.startAfter(startAfter)
        .onSnapshot(snapshot => {
          dispatch('processregister', { snapshot, collection, register, details, orderBy })
        })
    },
    async processregister({ state, commit, dispatch }, { snapshot, collection, register, details, orderBy, unshift }) {
      const changes = snapshot.docChanges()
      const registers = []
      for (const [idx, el] of changes.entries()) {
        const data = { id: el.doc.id, ...el.doc.data() }
        registers.push(data)
        if (el.type == 'added' || el.type == 'modified') {
          commit('setRegister', { register, data, unshift })
        }
        else if (el.type == 'removed') { commit('removeRegister', { register, data }) }
      }

      // GET Detalhes em outras collections baseada nos registros encontrados
      if (details) {
        registers.forEach(register => {
          details.forEach(detail => {
            dispatch('getDetails', { item: this._vm.$_.cloneDeep(register), detail: this._vm.$_.cloneDeep(detail) })
          });
        });
      }

      // Grava último id para próxima iteração
      const last = snapshot.docs[snapshot.docs.length - 1];
      let lastDocCursor = null
      if (snapshot.docs.length > 0) {
        let order = (Array.isArray(orderBy)) ? orderBy : [orderBy]
        lastDocCursor = []
        for (const el of order) {
          if (el && typeof el == 'string') {
            lastDocCursor.push(last.data()[el])
          } else if (el && typeof el != 'string' && el.key.includes('.')) {
            const path = el.key.split('.')
            let lastData = last.data()
            for (const p of path) {
              lastData = lastData[p]
            }
            lastDocCursor.push(lastData)
          } else if (el && typeof el != 'string') {
            lastDocCursor.push(last.data()[el.key])
          } else {
            lastDocCursor.push(last.id)
          }
        }
      }
      this._vm.$set(state.observers[register], 'lastDocCursor', lastDocCursor)
      this._vm.$set(state.loading, [register], false)
    },

    // GET Details
    async getDetails({ dispatch }, { item, detail, endSlice = 1 }) {
      const { collection, register, filters, orderBy } = detail
      let get = true
      // Replace Filters
      filters.forEach(elx => {
        if (typeof elx.value == 'string' && elx.value.includes('res.')) {
          const path = elx.value.split('.')
          path.shift()
          let value = this._vm.$_.cloneDeep(item)
          path.forEach(ely => {
            const newValue = value[ely]
            if (value && Array.isArray(newValue) && newValue.length > 0) value = newValue.filter(x => x).slice(0, endSlice)
            else if (value && typeof newValue == 'string' && newValue) value = [newValue]
            else if (value && typeof newValue == 'boolean') value = newValue
            else if (value && typeof newValue == 'object' && !Array.isArray(newValue) && newValue) value = newValue
            else {
              value = null
              get = false
            }
          });
          elx.value = value
        }
      });
      if (get) dispatch('get', { collection, register, filters, orderBy })
    },

    // GET
    async get({ commit, dispatch }, { collection, register = collection, filters, orderBy, query, limit = 10, ref, setRegister = true, forceFilter }) {
      const gpEmpresa = await dispatch('getGpEmpresa', collection)
      const filial = await dispatch('getFilial', collection)
      collection = collection + gpEmpresa
      if (!ref) ref = this._vm.$db().collection(collection)

      // FILTERS
      if (filters) ref = await dispatch('mountedFilters', { ref, filters, register, forceFilter })
      if (!ref) return

      ref = ref.where('lifeControl.deletedAt', '==', null)
      if (filial) ref = ref.where('filial', '==', filial)

      // ORDER BY
      if (limit != 1) {
        let order = (Array.isArray(orderBy)) ? orderBy : [orderBy]
        for (const el of order) {
          if (el && typeof el == 'string') {
            ref = ref.orderBy(el)
          } else if (el && typeof el != 'string') {
            ref = ref.orderBy(el.key, el.mod)
          } else {
            ref = ref.orderBy(this._vm.$db.FieldPath.documentId())
          }
        }
      }

      // START AT
      if (query) { ref = ref.startAt(filial + query).endAt(`${filial + query}\uf8ff`) }

      // LIMIT
      if (limit) ref = ref.limit(limit)

      const registerSnapshot = await ref.get()
      // console.info('get', collection, register, filters, orderBy, query, limit, ref, setRegister, registerSnapshot)

      const registers = []
      registerSnapshot.forEach(doc => {
        const data = { id: doc.id, ...doc.data() }
        registers.push(data)
        if (register && setRegister) commit('setRegister', { register, data })
      });
      return registers
    },

    // GET BY ID
    async getById({ commit, dispatch }, { collection, register = collection, id, subCollection, orderSubcollection, setRegister = true, getFilial = true }) {
      const gpEmpresa = await dispatch('getGpEmpresa', collection)
      if (getFilial) {
        const filial = await dispatch('getFilial', collection)
        id = filial + id
      }
      collection = collection + gpEmpresa
      let ref = this._vm.$db().collection(collection).doc(id)

      const doc = await ref.get()
      // console.info('getById', collection, register, id, subCollection, setRegister, doc)
      if (!doc.exists) return
      const data = { id: doc.id, ...doc.data() }

      if (subCollection) {
        const refSub = this._vm.$db().collection(collection).doc(id).collection(subCollection)

        data[subCollection] = await dispatch('get', { ref: refSub, orderBy: orderSubcollection, limit: null, setRegister: false })
      }

      if (register && setRegister) commit('setRegister', { register, data })
      return data
    },

    // CRUD
    async save({ commit, dispatch }, { collection, item, notToast = false, integration = false, collectionDetails, itemsDetails, submitToErp, submitToApproval }) {
      const originalCollection = collection
      if (integration) {
        const gpEmpresa = await dispatch('getGpEmpresa', collection)
        const filial = await dispatch('getFilial', collection)
        collection = collection + gpEmpresa
        item.gpEmpresa = gpEmpresa.slice(0, -1)
        item.filial = filial
        item.status = 'Rascunho'
        item.errorErp = ''
      }

      if (submitToApproval) {
        item.submitToApproval = true
        item.status = 'Pendente de Aprovação'
        item.bloqueado = true
      }
      
      commit('setLoading', { stats: true }, { root: true })
      const method = (item.id) ? 'patch' : 'post'
      let urlMaster = (integration) ? `/integration` : ``
      urlMaster += (item.id) ? `/${collection}/${item.id}` : `/${collection}`

      // console.info(collection, item, integration, collectionDetails, itemsDetails, submitToErp, urlMaster)
      return this._vm.$api[method](encodeURI(urlMaster), item)
        .then(async res => {
          const item = res.data.data
       
          if (collectionDetails) {
            const gpEmpresa = await dispatch('getGpEmpresa', collectionDetails)
            const filial = await dispatch('getFilial', collectionDetails)
            collectionDetails = collectionDetails + gpEmpresa
            const urlDetails = `/integration/batch/${collection}/${collectionDetails}?set=true&clearSubCollections=true`
            itemsDetails = itemsDetails.map((x, ix) => {
              return {
                ...x.data,
                id: res.data.data.id + (ix + 1).toString().padStart(4, '0'),
                idParent: res.data.data.id,
                gpEmpresa,
                filial
              }
            })
            await this._vm.$api.post(urlDetails, itemsDetails)
          }

          // TODO Alterar para transação
          if (submitToErp) {
            item.submitToErp = true
            item.status = 'Pronto para o envio'
            item.bloqueado = true
            await this._vm.$api.patch(`/integration/${collection}/${item.id}`, item)
          }

          if (!notToast) {
            let message = 'Registro Salvo!'

            if (integration) {
              const _integration = this._vm.$integrations.find(x => x.collection === originalCollection)
              if ( method == 'patch' && _integration?.editSuccessMessage
                || method == 'post'  && _integration?.registerSuccessMessage ) {
                try {
                  /**
                   * @TODO melhorar a segurança do eval.
                   * está permitindo acesso a todo o escopo do código e a execução de qualquer código,
                   * sendo assim uma falha de segurança.
                   */
                  message = method == 'patch' ? eval(_integration.editSuccessMessage) : eval(_integration.registerSuccessMessage)
                } catch (err) {
                  console.error('save: Error on eval successMessage', err)
                }
              }
            }

            this._vm.$toast.success(message, { position: 'top-right' })
          }

          return res
        })
        .catch(error => { throw (error.response && error.response.data) ? error.response.data.error : error })
        .finally(() => commit('setLoading', { stats: false }, { root: true }))
    },
    async remove({ commit, dispatch }, { collection, item, integration = false }) {
      commit('setLoading', { stats: true }, { root: true })
      const gpEmpresa = await dispatch('getGpEmpresa', collection)
      const originalCollection = collection
      collection = collection + gpEmpresa
      let url = (integration) ? `/integration` : ``
      url += `/${collection}/${item.id}`
      if (item.id) {
        return this._vm.$api.delete(url)
          .then(res => {
            commit('setRecentRemove', true)
            let message = 'Registro Deletado!'
            if (integration) {
              const _integration = this._vm.$integrations.find(x => x.collection === originalCollection)
              if (_integration?.deleteSuccessMessage) {
                try {
                  /**
                   * @TODO melhorar a segurança do eval.
                   * está permitindo acesso a todo o escopo do código e a execução de qualquer código,
                   * sendo assim uma falha de segurança.
                   */
                  message = eval(_integration.deleteSuccessMessage)
                } catch (err) {
                  console.error('save: Error on eval successMessage', err)
                }
              }
            }
            this._vm.$toast.success(message, { position: 'top-right' })
            return res
          })
          .catch(error => {
            console.error(error)
            return error
          })
          .finally(() => commit('setLoading', { stats: false }, { root: true }))
      }
    },
    async calculaImpostos({ dispatch, rootState }, { item, itemsDetails, collectionDetails }) {
      if (collectionDetails) {
        const gpEmpresa = await dispatch('getGpEmpresa', collectionDetails)
        const filial = await dispatch('getFilial', collectionDetails)
        collectionDetails = collectionDetails + gpEmpresa
        item.GPEMPRESA = gpEmpresa.slice(0, -1)
        item.FILIAL = filial
        item[collectionDetails] = []
        for (const x of itemsDetails) { item[collectionDetails].push({ ...x.data, GPEMPRESA: gpEmpresa, FILIAL: filial }) }
      }
      //TODO Arrumar limpeza do item
      delete item.DA0
      delete item.SA1
      delete item.SA3
      delete item.SA4
      delete item.SE4
      delete item._user
      return this._vm.$api.post('/protheus/calculaImpostos', item, { timeout: rootState.protheus.timeout, noToast: true })
        .then(res => res.data.data)
        .catch(error => error)
    },

    async sendFile({ dispatch}, { file, collection, numSite, entityKey, filEnt  }) {
      const gpEmpresa = await dispatch('getGpEmpresa', collection)            
      const options = { headers: {'Content-Type': 'multipart/form-data'} } 
      const oMsg = new FormData();
      
      oMsg.append('gpEmpresa', gpEmpresa.slice(0, -1))
      oMsg.append('entity', collection)
      oMsg.append('file', file)
      oMsg.append('numSite', numSite)
      oMsg.append('entityKey', entityKey)
      oMsg.append('filEnt', filEnt)

      return this._vm.$api.post('/protheus/upload',oMsg, options)
        .then(res => {
          res.data.data
          this._vm.$toast.success('Upload realizado!', { position: 'top-right' })
        })
        .catch(error => {
          this._vm.$toast.error('Erro no upload!', { position: 'top-right' })
        })
    },

    async getFiles({ dispatch }, { collection, numSite, entityKey, filent  }) {
      const gpEmpresa = await dispatch('getGpEmpresa', collection)      
      
      return this._vm.$api.get(`/protheus?path=uftools/upload/files&emp=${gpEmpresa.slice(0, -1)}&cNumSite=${numSite}&cEntidade=${collection}&cKeyEntidade=${entityKey}&cFilent=${filent}`)
        .then(res => res.data.files )
        .catch(error => error)
    },

    async getFile({ dispatch }, { collection, codObj  }) {
      const gpEmpresa = await dispatch('getGpEmpresa', collection)      
      const filial = '01'//TODO Verificar pq aqui sera o compartilhamento do BC
      
      return this._vm.$api.get(`/protheus?path=uftools/upload/file&emp=${gpEmpresa.slice(0, -1)}&cCodOBJ=${codObj}&_cFilial=${filial}&cEntidade=${collection}`)
        .then(res => res.data )
        .catch(error => error)
    },

    removeBundle({ commit }, { collection, itens }) {
      const ids = itens.map(x => x.id)
      commit('setLoading', { stats: true }, { root: true })
      if (itens.length > 0) {
        return this._vm.$api.patch(`/${collection}/remove`, ids)
          .then(res => {
            this._vm.$toast.success('Registros Deletados!', { position: 'top-right' })
            return res
          })
          .catch(error => {
            console.error(error)
            return error
          })
          .finally(() => commit('setLoading', { stats: false }, { root: true }))
      }
    },
    async count({ state, commit }, { collection }) {
      const snapshot = this._vm.$db()
        .collection('counts')
        .doc(collection)
        .collection('shards')
        .onSnapshot(snapshot => {
          let count = 0;
          for (const doc of snapshot.docs) {
            count += doc.get('count');
          }
          commit('setCounter', { collection, count })
        })

      // Grava listener para encerramento posterior
      if (state.observers['counts'].snapshots && state.observers['counts'].snapshots.length > 0) { state.observers['counts'].snapshots.push(snapshot) }
      else { state.observers['counts'].snapshots = [snapshot] }
      this._vm.$set(state.observers['counts'], 'snapshots', state.observers['counts'].snapshots)
    },
    import({ commit }, { collection, item }) {
      commit('setLoading', { stats: true }, { root: true })

      const options = { headers: { 'Content-Type': 'multipart/form-data' } }
      const payload = new FormData();
      for (const key in item) {
        switch (key) {
          case 'file':
            payload.append(key, item[key])
            break;
          default:
            payload.append(key, stringify(item[key]))
            break;
        }
      }

      const method = 'post'
      const url = `/${collection}/import`
      return this._vm.$api[method](url, payload, options)
        .then(res => {
          const { data } = res.data
          this._vm.$toast.success(data.message, { position: 'top-right' })
          return res
        })
        .catch(error => { throw error.response.data.error || error.response.data })
        .finally(() => commit('setLoading', { stats: false }, { root: true }))
    },
    async searchAlgolian({ state, dispatch, rootState }, { index, query, facetFilters = [], restrictSearchableAttributes = [], attributesToRetrieve = ['*'], attributesToHighlight = [], hitsPerPage = 1000 }) {
      
      if (state.counters.searchAlgolian > (rootState.algolia.searchLimit)) {
        this._vm.$toast.error('A consulta não pode ser concluída pois o limite de consultas do algolia já foi alcançado.')
        return { hits: [] }
      } 

      const compareFilters = (last, actual) => last.length == actual.length && actual.every((arr, idx) => arr.length == last.length && arr.every((str, idx2) => str == last[idx][idx2]))
      if (!rootState.algolia || (state.lastAlgoliaReqParams.query == query && compareFilters(state.lastAlgoliaReqParams.facetFilters, facetFilters))) {
        console.warn('searchAlgolian: prevent searching the same query as last one.')
        return { hits: [] }
      }
      state.lastAlgoliaReqParams = { query, facetFilters }

      // PREPARE ENVIROMENT
      const gpEmpresa = await dispatch('getGpEmpresa', index)
      const filial = await dispatch('getFilial', index)

      // FILTERS
      const integration = this._vm.$integrations.find(x => x.collection === index)
      if (integration) {
        let { filters } = integration
        if (filters) filters = await dispatch('mountedFilters', { filters: JSON.parse(filters), register: index })
        if (!filters) return

        for (const { key, operator, value } of filters) {
          facetFilters.push([`${key}:${value}`])
        }

        if (filial) facetFilters.push([`filial:${filial}`])

      } else {
        console.warn(`searchAlgolian: Couldn't find integration '${index}'.`)
      }

      // collection = collection+gpEmpresa

      const modifiedIndex = index + gpEmpresa
      const client = algoliasearch(rootState.algolia.appId, rootState.algolia.searchApiKey);
      const ix = client.initIndex(modifiedIndex);
      return ix.search(query, {
        'facetFilters': facetFilters,
        'restrictSearchableAttributes': restrictSearchableAttributes,
        'attributesToRetrieve': attributesToRetrieve,
        'attributesToHighlight': attributesToHighlight,
        'hitsPerPage': hitsPerPage
      })
        .then(result => {
          // console.info(index, modifiedIndex, query, result, facetFilters, restrictSearchableAttributes, attributesToRetrieve, attributesToHighlight, hitsPerPage)
          this._vm.$api.put('/counters/searchAlgolian', {}, {})
            .then(res => res)
            .catch(error => { throw error.response.data.error || error.response.data })
          return { index, modifiedIndex, ...result }
        })
        .catch(e => e)
    },
    async getOnMongo({state, commit, dispatch, rootState}, payload){
      let {register, collection, subCollection, idParent = null, id, filters, orFilters, dateRange, fields, orderBy, getTotal, limit, getDeleteds, startAfter, resetRegister = false, onSnapshot = false, forceFilter = true, getFirestore = false, disableIntFilters = false, noState = false} = payload
      const originalRegister = register.replace('Filtered', '')
      commit('setLoading', {register, status: true})
      commit('setLoading', {register: originalRegister, status: true})

      // PREPARE ENVIROMENT
      const tenantId = 'elettromec'
      let gpEmpresa = await dispatch('getGpEmpresa', collection)
      gpEmpresa = gpEmpresa.slice(0, -1)
      const filial = await dispatch('getFilial', collection)
      if (!idParent && subCollection) idParent = gpEmpresa+filial+id
      
      if (resetRegister) { commit('resetRegister', register)  }
      if (!startAfter) { getTotal = true}
      
      // FILTERS
      if (filters) {
        filters = filters.map(x => {
          let filter = Array.isArray(x) ? x[0] : null
          let operator = ''
          if (filter && filter.includes(':')) {
            filter = filter.split(':') 
            operator = '=='
          }
          if (filter && filter.includes('~~')) {
            filter = filter.split('~~') 
            operator = '~~'
          }
          if (filter && filter.includes('~')) {
            filter = filter.split('~') 
            operator = '~'
          }
          if (filter && filter.includes('!=')) {
            filter = filter.split('!=') 
            operator = '!='
          }
          if (filter && filter.includes('>')) {
            filter = filter.split('>') 
            operator = '>'
          }
          if (filter && filter.includes('>=')) {
            filter = filter.split('>=') 
            operator = '>='
          }
          if (filter && filter.includes('<')) {
            filter = filter.split('<') 
            operator = '<'
          }
          if (filter && filter.includes('<=')) {
            filter = filter.split('<=') 
            operator = '<='
          }
          if (filter && filter.length > 1) {
            x = {
              key: filter[0],
              operator,
              value: filter[1]
            }
          }

          if (x.key == 'status') { x.operator = 'like' }
          return x
        })
        filters = await dispatch('mountedFilters', { filters, register, tenantId, forceFilter })
        if (!filters) return
      } else {
        filters = []
      }

      const user = rootState.auth.user
      const integration = this._vm.$integrations.find(x => x.collection === (subCollection || collection))
      if (integration && !disableIntFilters) {
        let { filters:_filters, filtersSaller, filtersClient } = integration
        if (_filters) { 
          _filters = await dispatch('mountedFilters', { filters: JSON.parse(_filters), register, tenantId, userLogged: user }) 
          if (!_filters) {
            commit('setLoading', {register, status: false})
            commit('setLoading', {register: originalRegister, status: false})
            return
          }
        } else { _filters = [] }

        if (filtersClient && user?.companies && user?.companies[tenantId]?.A1_COD?.trim()) {
          filtersClient = await dispatch('mountedFilters', { filters: JSON.parse(filtersClient), register, tenantId, userLogged: user })
        } else { filtersClient = [] }
        
        if (filtersSaller) {
          filtersSaller = await dispatch('mountedFilters', { filters: JSON.parse(filtersSaller), register, tenantId, userLogged: user }) 
        } else {
          filtersSaller = []
        }
        if (_filters) filters = [...filters, ..._filters]
        if (filtersClient) filters = [...filters, ...filtersClient]
        if (filtersSaller) filters = [...filters, ...filtersSaller]
      }

      if (onSnapshot || getFirestore) { 
        if (!fields) fields = []
        fields.push('idFirestore')
      }

      return this._vm.$api.get(`/mongodb/${(subCollection) ? `${collection}.${subCollection}` : collection}`, {
        tenantId,
        noToast: true,
        params: {
          superUser: user.superAdmin ? true : false, 
          gpEmpresa: gpEmpresa,
          filial,
          idParent,
          filters: JSON.stringify(filters),
          orFilters: JSON.stringify(orFilters),
          dateRange: JSON.stringify(dateRange),
          fields: JSON.stringify(fields),
          orderBy: (typeof orderBy != 'string') ? JSON.stringify(orderBy) : orderBy,
          getTotal,
          limit,
          getDeleteds,
          startAfter
        }
      })
        .then(async res => {
          if (res.status == 200) {
            const {meta, data} = res.data
            
            if (onSnapshot || getFirestore) {
              if (getFirestore) res.data.data = []
              // Em tempo real
              const ids = data.map(x => x.id)
              if (ids && ids.length > 0) {
                const chunks = []
                for (let ix = 0; ix < ids.length/10; ix++) {
                  chunks.push(ids.slice(ix*10, (ix+1)*10))
                }
                for (const el of chunks) {
                  if (onSnapshot) {
                    dispatch(
                      'observer', 
                      {
                        collection, 
                        register, 
                        filters: [{
                          key: this._vm.$db.FieldPath.documentId(), 
                          operator: 'in', 
                          value: el
                        }],
                        limit: el.length,
                        disableIntFilters: true,
                        notUnshift: true,
                        forceFilter
                      }
                    )
                  } else if (getFirestore) {
                    const regs = await dispatch(
                      'get', 
                      {
                        collection: (subCollection && idParent) ? `${collection}/${idParent}/${subCollection}` : collection, 
                        register, 
                        filters: [{
                          key: this._vm.$db.FieldPath.documentId(), 
                          operator: 'in', 
                          value: el
                        }],
                        limit: el.length,
                        disableIntFilters: true,
                        forceFilter,
                        resetRegister
                      }
                    )
                    for (const reg of regs) {
                      const ix = res.data.data.findIndex(x => x.id === reg.id)
                      if (ix > -1) {
                        res.data.data[ix] = reg
                      } else {
                        res.data.data.push(reg)
                      }
                    }
                  }
                  // desabilida o reset após a primeira pagina
                  resetRegister = false
                }
              }

              if (getFirestore) {
                res.data.data = res.data.data.sort((a, b) => {
                  if (!Array.isArray(orderBy)) { orderBy = [orderBy] }
                  
                  for (const el of orderBy) {
                    let field = el.field || el.key
                    let mod = 1
                    if (field) {
                      mod = (el.mod && (el.mod.toLowerCase() == 'desc' || el.mod == -1)) ? -1 : 1
                    } else {
                      field = el
                    } 
                    if (!field) { return 0 }
                    if (a[field] < b[field]) return -1*mod
                    if (a[field] > b[field]) return 1*mod
                    continue
                  }
                  return 0
                })
              }
            } else {
              // Estatico
              for (const el of data) {
                commit('setRegister', { register, data:el })
                if (register.includes('Filtered')) { commit('setRegister', { register: originalRegister, data:el }) }
              }
            }

            // Referencias para paginação
            if (!state.mongodb[register]) {
              state.mongodb[register] = {}
            }
            if (!noState) { this._vm.$set(state.mongodb[register], 'payload', payload) }
            if (meta && meta.lastDocCursor) {
              if (!noState) { this._vm.$set(state.mongodb[register], 'lastDocCursor', meta.lastDocCursor) }
            } else {
              if (!noState) { this._vm.$set(state.mongodb[register], 'lastDocCursor', null) }
            }
          }

          return res
        })
        .then(res => (res.status == 200) ? res.data : null)
        .catch(err => {
          if (!noState && state.mongodb[register]) this._vm.$set(state.mongodb[register], 'lastDocCursor', null)
          return err
        })
        .finally(() => {
          // console.info('getOnMongo', {collection, subCollection, originalRegister, register, idParent, filters, orFilters, dateRange, fields, orderBy, getTotal, limit, getDeleteds, startAfter, onSnapshot, getFirestore})
          commit('setLoading', {register, status: false})
          commit('setLoading', {register: originalRegister, status: false})
        })
    },
    async nextOnMongo({ state, dispatch }, { register, limit }) {
      const lastDocCursor = state.mongodb[register].lastDocCursor
      if (!lastDocCursor) { return }
      const payload = state.mongodb[register].payload
      if (limit) payload.limit = limit
      return await dispatch('getOnMongo', {...payload, getTotal: false, startAfter: lastDocCursor})
    }
  }
}

export default register